import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { SecureDocument } from '../models/secureDocument';
import { DocumentType, WhatsappRequest } from '../models/whatsappRequest';

@Component({
  selector: 'app-documentviewer',
  templateUrl: './documentviewer.component.html',
  styleUrls: ['./documentviewer.component.scss']
})
export class DocumentviewerComponent implements OnInit {

  private doc: SecureDocument;
  public docurl : string;
  private doctype : DocumentType;

  constructor(private data: DataService, private router: Router,private _sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.doc = this.data.ActiveDocumentViewRequest.Document;
    this.GetSecureUrl(this.doc.storagekey);
    this.doctype = this.data.ActiveDocumentViewRequest.DocType;
  }

  public GetSecureUrl(key: string) {
    this.data.request<string>("kiosk/secureurl/doc/" + key, null, "GET").subscribe((v) => {
        //this.docurl = this._sanitizer.bypassSecurityTrustResourceUrl(v);
        this.docurl = v;
        console.log(this.docurl);
    },(error)=>{
      console.log("error : " + error)
    });
  }

  onEmail() : boolean {
    this.data.MailReqEx = {
      MailResources : [
        {
          Title : this.data.ActiveDocumentViewRequest.Document.title,
          URL : this.data.ActiveDocumentViewRequest.Document.storagekey,
          ResourceType : "doc"}
      ]
    }

    this.router.navigate(['mailprogress']);
    return false;
  }

  onWhatsapp() : boolean {

    var wpreq = new WhatsappRequest
    wpreq.FileName = this.doc.title;
    wpreq.HasMedia = true;
    wpreq.MediaUrl = this.doc.storagekey;
    wpreq.Mesage = ""; //Mostly this will be directly set by the messenger
    wpreq.MessageDocumentType = this.doctype;

    this.data.WhatsappReq = wpreq;

    this.router.navigate(['whatsappprogress']);
    return false;

  }


}
